module.exports = __webpack_public_path__ + "static/media/alex-tosolini.f345f3df.jpeg";